import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addGetInTouch = (postData) => {
  return http().post(endpoints.forms.getInTouch, postData);
};

export function useGetInTouch() {
  return useMutation(addGetInTouch, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
